<template>
  <div>
    <b-modal
      v-model="showModalCalendar"
      size="sm"
      title="Challenge Calendar"
      hide-header-close
      centered
      @hidden="resetModal"
      noCloseOnEsc
    >
      <div class="mx-2 mb-3">
        <p class="text-muted small">
          See dates for when you have rated child goals. You can select a date within 5 days and
          rate the goals.
        </p>
      </div>
      <b-calendar
        v-model="calendarDate"
        :date-info-fn="dateClass"
        :date-disabled-fn="dateDisabled"
        block
        selected-variant="warning"
        class="mb-3"
      ></b-calendar>
      <div v-if="isEmptyDate" class="small badge-danger rounded-pill text-center m-auto px-2 py-1">
        Selected date is empty
      </div>
      <section>
        <ul class="label-list">
          <li v-for="(label, status) in backgroundByStateDate" :key="status" class="label-item">
            <div class="label-sample" :class="label"></div>
            {{ status.replace('_', ' ') }}
          </li>
        </ul>
      </section>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="warning" block :disabled="!calendarDate" @click="updateChellenge">
            Go
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    dates: Array,
    editableDates: Array,
    availableDates: Array,
  },
  data() {
    return {
      showModalCalendar: false,
      isEmptyDate: false,
      calendarDate: null,
      selectedDate: null,
      backgroundByStateDate: {
        all_done: 'table-success',
        partial: 'table-warning',
        nothing: 'table-danger',
      },
    };
  },
  methods: {
    ...mapActions('challenge', ['FetchChildCriterionValuesByDate']),
    resetModal() {
      this.showModalCalendar = false;
      this.$emit('onClose', false);
    },
    openCalendar() {
      this.showModalCalendar = true;
    },
    dateClass(dateFormatYMD) {
      if (!this.editableDatesAdapter.has(dateFormatYMD)) return '';

      return this.backgroundByStateDate[this.editableDatesAdapter.get(dateFormatYMD)];
    },
    dateDisabled(dateFormatYMD) {
      const isDisabled =
        !this.availableDatesAdapter.has(dateFormatYMD) &&
        !this.editableDatesAdapter.has(dateFormatYMD);

      return isDisabled;
    },
    updateChellenge() {
      this.$emit('change-date', this.calendarDate);
    },
    datesAdapter(dates) {
      const datesAdapted = new Map();
      dates.forEach(([date, status]) => datesAdapted.set(date, status));

      return datesAdapted;
    },
  },
  computed: {
    ...mapGetters('challenge', ['getCriterionValues']),
    getSelectedDate() {
      return this.selectedDate;
    },
    availableDatesAdapter() {
      return this.datesAdapter(this.availableDates);
    },
    editableDatesAdapter() {
      return this.datesAdapter(this.editableDates);
    },
  },
};
</script>

<style scope lang="scss">
.table {
  &-danger {
    background-color: #ff4f4f;
  }

  &-warning {
    background-color: #ffeb3b;
  }

  &-success {
    background-color: #80d127;
  }
}

.label {
  &-list {
    margin: 0;
    list-style: none;

    font-size: 0.8rem;
  }

  &-sample {
    width: 15px;
    aspect-ratio: 1;
    margin-right: 0.5rem;
    display: inline-block;
  }
}
</style>
